module.exports = __webpack_public_path__ + "static/img/pc-main-visual.94ee4bc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pc-main-visual.png
// module id = 7E+E
// module chunks = 1